/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-parallax.js
 *
 * スクロールに合わせて実行するパララックスアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/**
 * パララックス - テキスト
 * スクロールに合わせて実行するパララックス
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setparallaxText = () => {

  /**
   * 処理
   */
  setparallaxText_X()
  setparallaxText_Y()

  /**
   * X軸   
   */
  function setparallaxText_X() {
    gsap.utils.toArray('.parallaxText.--X').forEach((parallaxText_X, i) => {
      let start = JSON.parse(parallaxText_X.dataset.start);
      let end = JSON.parse(parallaxText_X.dataset.end);
      gsap.set(parallaxText_X, {
        xPercent: start,
      })
      gsap.registerEffect({
        name: "parallaxText_X",
        effect: (targets, config) => {
          return gsap.to(targets, {
            xPercent: end,
            scrollTrigger: {
              trigger: targets,
              start: "top 80%",
              end: "bottom top",
              scrub: 2,
              // markers: true,
            },
          });
        },
      })
      gsap.effects.parallaxText_X(parallaxText_X);
    });
  }

  /**
   * Y軸 
   */
  function setparallaxText_Y() {
    gsap.utils.toArray('.parallaxText.--Y').forEach((parallaxText_Y, i) => {
      let start = JSON.parse(parallaxText_Y.dataset.start);
      let end = JSON.parse(parallaxText_Y.dataset.end);
      gsap.set(parallaxText_Y, {
        yPercent: start,
      })
      gsap.registerEffect({
        name: "parallaxText_Y",
        effect: (targets, config) => {
          return gsap.to(targets, {
            yPercent: end,
            scrollTrigger: {
              trigger: targets,
              start: "top 80%",
              end: "bottom top",
              scrub: 2,
              // markers: true,
            },
          });
        },
      })
      gsap.effects.parallaxText_Y(parallaxText_Y);
    });
  }

};

/**
 * パララックス - img
 * スクロールに合わせて実行するパララックス
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setparallaxImg = () => {

  /**
   * 処理
   */
  // setparallaxImg_X()
  setparallaxImg_Y()

  /**
   * X軸
   */
  function setparallaxImg_X() {
    gsap.utils.toArray('.parallaxImg.--X').forEach((parallaxImg_X, i) => {
      let start = JSON.parse(parallaxImg_X.dataset.start);
      let end = JSON.parse(parallaxImg_X.dataset.end);
      gsap.set(parallaxImg_X, {
        xPercent: start,
      })
      gsap.registerEffect({
        name: "parallaxImg_X",
        effect: (targets, config) => {
          return gsap.to(targets, {
            xPercent: end,
            scrollTrigger: {
              trigger: targets,
              start: "top 80%",
              end: "bottom top",
              scrub: 2,
              // markers: true,
            },
          });
        },
      })
      gsap.effects.parallaxImg_X(parallaxImg_X);
    });
  }

  /**
   * Y軸
   */
  function setparallaxImg_Y() {
    gsap.utils.toArray('.parallaxImg.--Y').forEach((parallaxImg_Y, i) => {
      let start = JSON.parse(parallaxImg_Y.dataset.start);
      let end = JSON.parse(parallaxImg_Y.dataset.end);
      gsap.set(parallaxImg_Y, {
        yPercent: start,
      })
      gsap.registerEffect({
        name: "parallaxImg_Y",
        effect: (targets, config) => {
          return gsap.to(targets, {
            yPercent: end,
            ease: "none",
            scrollTrigger: {
              trigger: targets,
              start: "top 80%",
              end: "bottom top",
              scrub: 2,
              // markers: true,
            },
          });
        },
      })
      gsap.effects.parallaxImg_Y(parallaxImg_Y);
    });
  }
};

/**
 * 処理
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function scrollTriggerParallax() {
  // setparallaxText();
  setparallaxImg();
}


/**
 *  Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export {
  scrollTriggerParallax
};